import React from "react";
import { cn } from "../../lib/cn";

const colors = {
  green: "bg-emerald-50 text-emerald-800 border-emerald-200",
  red: "bg-red-50 text-red-800 border-red-200",
  blue: "bg-sky-50 text-sky-800 border-sky-200",
  cyan: "bg-cyan-50 text-cyan-900 border-cyan-200",
  orange: "bg-amber-50 text-amber-900 border-amber-200",
  gold: "bg-amber-50 text-amber-900 border-amber-200",
  purple: "bg-violet-50 text-violet-900 border-violet-200",
  magenta: "bg-fuchsia-50 text-fuchsia-900 border-fuchsia-200",
  geekblue: "bg-indigo-50 text-indigo-900 border-indigo-200",
  default: "bg-slate-100 text-slate-800 border-slate-200",
};

export function Tag({ children, color = "default", className, closable, onClose }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        colors[color] || colors.default,
        className
      )}
    >
      {children}
      {closable ? (
        <button
          type="button"
          className="ml-0.5 rounded p-0.5 hover:bg-black/10"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      ) : null}
    </span>
  );
}
